import React from 'react';
import { copy, Language } from '../content/i18n';

const SOCIAL = [
  {
    id: 'instagram',
    href: 'https://www.instagram.com/sazacoffee',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    id: 'youtube',
    href: 'https://youtube.com/@sazachannel?si=dCGVgr3eOaXjz1nr',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
        <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    id: 'facebook',
    href: 'https://ja-jp.facebook.com/189423174464394/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
      </svg>
    ),
  },
  {
    id: 'x',
    href: 'https://x.com/saza_coffee',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
];

const QR_ITEMS = [
  {
    id: 'officialApp',
    href: 'https://saza.co.jp/app/',
    qrSrc: 'https://saza.coffee/Contents/Feature/qr-app.png',
  },
  {
    id: 'onlineShop',
    href: 'https://saza.coffee/',
    qrSrc: 'https://saza.coffee/Contents/Feature/qr-wed.png',
  },
];

const MARKETPLACES = [
  {
    label: 'Amazon',
    href: 'https://www.amazon.co.jp/stores/page/376BCBDB-F41F-402F-BF98-F31AD23DBDAD',
    logoSrc: 'https://saza.coffee/Contents/Feature/amazon_logo.png',
    logoWidth: 100,
  },
  {
    label: 'Rakuten',
    href: 'https://www.rakuten.ne.jp/gold/sazacoffee/',
    logoSrc: 'https://saza.coffee/Contents/Feature/rakuten_logo.png',
    logoWidth: 120,
  },
];

const HANIKAH_INSTAGRAM = 'https://www.instagram.com/hanikahmedia/';
const RIBBON_REPEAT_COUNT = 8;
const RIBBON_GAP = 6;

interface FooterProps {
  language: Language;
}

const Footer: React.FC<FooterProps> = ({ language }) => {
  const t = copy[language].footer;

  return (
    <footer
      style={{
        background: '#040404',
        borderTop: '1px solid rgba(196,148,40,0.12)',
        padding: '56px 32px 28px',
      }}
    >
      <div style={{ maxWidth: 880, margin: '0 auto', textAlign: 'center' }}>
        {/* Geisha Hunter Logo */}
        {/* <div style={{ marginBottom: 22 }}>
          <img
            src="/plan/geisha-hunter-logo.png"
            alt="Geisha Hunter Documentary"
            style={{ height: 44, width: 'auto', opacity: 0.88, display: 'inline-block' }}
          />
        </div> */}

        {/* Amber rule */}
        {/* <div
          style={{
            width: 48,
            height: 1,
            background: 'rgba(196,148,40,0.45)',
            margin: '0 auto 24px',
          }}
        /> */}

        {/* Social icons */}
        <nav aria-label={t.socialNavAria}>
          <ul
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 22,
              listStyle: 'none',
              padding: 0,
              margin: '0 0 28px',
            }}
          >
            {SOCIAL.map(({ id, href, icon }) => (
              <li key={id}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t.socialLabels[id as keyof typeof t.socialLabels]}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'rgba(255,255,255,0.35)',
                    transition: 'color 0.3s ease',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.color = '#c49428';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(255,255,255,0.35)';
                  }}
                >
                  {icon}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div
          style={{
            marginBottom: 28,
            padding: '18px 16px 20px',
            border: '1px solid rgba(196,148,40,0.14)',
            background: 'rgba(255,255,255,0.01)',
          }}
        >
          <p
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: '0.5rem',
              letterSpacing: '0.3em',
              color: 'rgba(196,148,40,0.7)',
              textTransform: 'uppercase',
              margin: '0 0 14px',
              fontWeight: 600,
            }}
          >
            {t.appStoreTitle}
          </p>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
              gap: 14,
              maxWidth: 420,
              margin: '0 auto 16px',
            }}
          >
            {QR_ITEMS.map(({ id, href, qrSrc }) => (
              <a
                key={id}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={id === 'officialApp' ? t.officialApp : t.onlineShop}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div
                  style={{
                    background: '#fff',
                    padding: 8,
                    display: 'inline-block',
                    lineHeight: 0,
                  }}
                >
                  <img
                    src={qrSrc}
                    alt={`${id === 'officialApp' ? t.officialApp : t.onlineShop} QR code`}
                    style={{ width: 112, height: 112, display: 'block' }}
                    loading="lazy"
                  />
                </div>
                <p
                  style={{
                    margin: '8px 0 0',
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: '0.46rem',
                    letterSpacing: '0.2em',
                    color: 'rgba(255,255,255,0.62)',
                    textTransform: 'uppercase',
                    fontWeight: 500,
                  }}
                >
                  {id === 'officialApp' ? t.officialApp : t.onlineShop}
                </p>
              </a>
            ))}
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
              gap: 10,
            }}
          >
            {MARKETPLACES.map(({ label, href, logoSrc, logoWidth }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8,
                  border: '1px solid rgba(196,148,40,0.35)',
                  color: '#c49428',
                  textDecoration: 'none',
                  padding: '6px 10px',
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '0.5rem',
                  letterSpacing: '0.16em',
                  textTransform: 'uppercase',
                  transition: 'all 0.25s ease',
                }}
                onMouseEnter={(e) => {
                  const target = e.currentTarget as HTMLAnchorElement;
                  target.style.background = 'rgba(196,148,40,0.15)';
                  target.style.borderColor = 'rgba(196,148,40,0.65)';
                }}
                onMouseLeave={(e) => {
                  const target = e.currentTarget as HTMLAnchorElement;
                  target.style.background = 'transparent';
                  target.style.borderColor = 'rgba(196,148,40,0.35)';
                }}
              >
                <img
                  src={logoSrc}
                  alt={`${label} Saza Coffee Store`}
                  style={{ width: label === 'Amazon' ? 88 : 104, height: 'auto', display: 'block' }}
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </div>

        <div
          style={{
            margin: '0 0 28px',
            padding: '18px 0 22px',
            borderTop: '1px solid rgba(196,148,40,0.12)',
            borderBottom: '1px solid rgba(196,148,40,0.12)',
            background: 'linear-gradient(to bottom, rgba(255,255,255,0.015), rgba(255,255,255,0))',
          }}
        >
          {/* <p
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: '0.48rem',
              letterSpacing: '0.3em',
              color: 'rgba(196,148,40,0.68)',
              textTransform: 'uppercase',
              margin: '0 0 10px',
              fontWeight: 600,
            }}
          >
            In Partnership With
          </p> */}
          <a
            href="https://www.sazacoffee.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'block',
              textDecoration: 'none',
              width: '100vw',
              marginLeft: 'calc(50% - 50vw)',
              padding: '0 14px',
            }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr auto 1fr',
                alignItems: 'center',
                columnGap: 10,
                minHeight: 64,
              }}
            >
              <div
                aria-hidden="true"
                style={{
                  width: '100%',
                  height: 40,
                  overflow: 'hidden',
                  filter: 'drop-shadow(0 6px 16px rgba(0,0,0,0.24))',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: RIBBON_GAP,
                    width: 'max-content',
                    height: 40,
                    marginLeft: 'auto',
                  }}
                >
                  {Array.from({ length: RIBBON_REPEAT_COUNT }).map((_, index) => (
                    <img
                      key={`left-ribbon-${index}`}
                      src="/plan/long-ribbon.svg"
                      alt=""
                      style={{ height: 40, width: 'auto', display: 'block', flex: '0 0 auto' }}
                    />
                  ))}
                </div>
              </div>

              <img
                src="/plan/sazacoffee-red.svg"
                alt="Saza Coffee"
                style={{
                  height: 40,
                  width: 'auto',
                  maxWidth: 320,
                  display: 'block',
                  filter: 'drop-shadow(0 8px 22px rgba(0,0,0,0.28))',
                }}
              />

              <div
                aria-hidden="true"
                style={{
                  width: '100%',
                  height: 40,
                  overflow: 'hidden',
                  filter: 'drop-shadow(0 6px 16px rgba(0,0,0,0.24))',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: RIBBON_GAP,
                    width: 'max-content',
                    height: 40,
                  }}
                >
                  {Array.from({ length: RIBBON_REPEAT_COUNT }).map((_, index) => (
                    <img
                      key={`right-ribbon-${index}`}
                      src="/plan/long-ribbon.svg"
                      alt=""
                      style={{ height: 40, width: 'auto', display: 'block', flex: '0 0 auto' }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </a>
        </div>

        {/* Bottom row */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
          }}
        >
          <a
            href="https://www.hanikahmedia.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t.hanikahAria}
            style={{ display: 'inline-block', opacity: 0.4, transition: 'opacity 0.3s ease' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.opacity = '0.75'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.opacity = '0.4'; }}
          >
            <img
              src="/plan/hanikah-logo.svg"
              alt="Hanikah Media"
              style={{ height: 26, width: 'auto', display: 'block' }}
            />
          </a>
          <a
            href={HANIKAH_INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t.hanikahInstagramAria}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              border: '1px solid rgba(196,148,40,0.34)',
              color: 'rgba(255,255,255,0.72)',
              textDecoration: 'none',
              fontFamily: "'Montserrat', sans-serif",
              fontSize: '0.48rem',
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              padding: '6px 9px',
              lineHeight: 1,
              transition: 'all 0.25s ease',
            }}
            onMouseEnter={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.color = '#fff';
              target.style.borderColor = 'rgba(196,148,40,0.8)';
              target.style.background = 'rgba(196,148,40,0.12)';
            }}
            onMouseLeave={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.color = 'rgba(255,255,255,0.72)';
              target.style.borderColor = 'rgba(196,148,40,0.34)';
              target.style.background = 'transparent';
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="2.5" y="2.5" width="19" height="19" rx="5" ry="5" />
              <circle cx="12" cy="12" r="4" />
              <circle cx="17.6" cy="6.4" r="0.7" fill="currentColor" stroke="none" />
            </svg>
            <span>{t.hanikahInstagramHandle}</span>
          </a>
          <span
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: '0.5rem',
              color: 'rgba(255,255,255,0.2)',
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
            }}
          >
            © {new Date().getFullYear()} {t.rightsReserved}
          </span>
          {/* <a
            href="https://www.sazacoffee.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              opacity: 0.3,
              transition: 'opacity 0.3s ease',
            }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.opacity = '0.65'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.opacity = '0.3'; }}
          >
            <img
              src="/plan/sazacoffee.png"
              alt="Saza Coffee"
              style={{ height: 18, width: 'auto', display: 'block' }}
            />
          </a> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
